<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data" class="workflow-tabs">
                            <div class="tab-content">
                                <input type="hidden" name="_token" :value="csrf">
                                <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Impostazioni di base</p>
                                    </div>
                                </div>
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.title")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]" :value="this.name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.description")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[description]" :value="this.description"><br>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.sorting")}}</label>
                                            <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="this.sorting">
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Settings Rows Answers</p>
                                    </div>
                                </div>
                                
                                <div class="row mb-3">
                                    <div class="col-2">
                                        <h6>Key</h6>
                                    </div>
                                    <div class="col-3">
                                        <h6>Column</h6>
                                    </div>
                                    <div class="col-3">
                                        <h6>Sorting</h6>
                                    </div>
                                    <div class="col-2">
                                        <h6>Color</h6>
                                    </div>
                                    <div class="col-2"></div>
                                </div>
                                <div class="row mb-1" v-for="(column,key) in columns" :key="key">
                                    <div class="col-2">
                                        <h6>{{key}}</h6>
                                    </div>
                                    <div class="col-3">
                                        <input class="form-control rounded" :name="'questionSettings[columns]['+key+'][label]'" :value="column.label">
                                    </div>
                                    <div class="col-3">
                                        <input class="form-control rounded" :name="'questionSettings[columns]['+key+'][sorting]'" :value="column.sorting">
                                        
                                    </div>
                                    <div class="col-1">
                                        <input class="form-control rounded" :name="'questionSettings[columns]['+key+'][color]'" type="color" :value="column.color">
                                        
                                    </div>
                                    <div class="col-2 text-right">
                                        <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="rmColumnPnP(key)"><i class="fas fa-times"></i></button>
                                        
                                    </div>
                                </div>
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Add new Answers</p>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-3">
                                        <div class="form-group">
                                            <input class="form-control rounded" v-model="newColumn" placeholder="New column">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            
                                            <input class="form-control rounded" type="number" v-model="newSorting" placeholder="Sorting">
                                        </div>
                                    </div>
                                    <div class="col-1">
                                        <div class="form-group">
                                            
                                            <input class="form-control rounded" type="color" v-model="newColor" placeholder="">
                                        </div>
                                    </div>
                                    
                                    <div class="col-2">
                                        <div class="form-group">
                                            
                                            <button class="btn" type="button" @click="addColumnPnP">Add Column</button>
                                            
                                        </div>
                                    </div>
                                    
                                </div>
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Range value</p>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label for="">Min value</label>
                                            <input class="form-control rounded" name="questionSettings[range_value][min]" type="number" min="1" :value="range_value['min']">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label for="">Max value</label>
                                            <input class="form-control rounded" name="questionSettings[range_value][max]" type="number" min="1" :value="range_value['max']">
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Graphs</p>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="custom-control custom-switch">
                                            <input name="questionSettings[graphs][bars]" type="checkbox" class="custom-control-input" id="questionSettings[graphs][bars]" value="1" v-model="bars">
                                            <label class="custom-control-label" for="questionSettings[graphs][bars]">
                                                Bars Graph
                                            </label>
                                        </div>     
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="custom-control custom-switch">
                                            <input name="questionSettings[graphs][radar]" type="checkbox" class="custom-control-input" id="questionSettings[graphs][radar]" value="1" v-model="radar">
                                            <label class="custom-control-label" for="questionSettings[graphs][radar]">
                                                Bars radar
                                            </label>
                                        </div>     
                                    </div> 
                                </div>
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <hr>
                                    </div>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    
    props: {
        can_write:{
            type:Boolean,
            required:true,
        }
    },
    data () {
        return {
            columns : [],
            radar : 0,
            bars : 0, 
            range_value : [],
            newColumn : "",
            newColor : "#00FF00",
            newSorting : 0,
            //default
            title: "P & P",
            active : false,
            action : "",
            name:"",
            description:"",
            sorting:-1,
            editing : true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        addColumnPnP(){
            //Check if
            
            if ( this.newColumn ==='' ){
                alert("You can't insert an empty column");
                return;
            }
            this.columns[this.newColumn] = {label : this.newColumn, sorting: this.newSorting, color : this.newColor};
            
            //Clean variables
            this.newColumn = "";
        },
        rmColumnPnP(index){
            //Delete element
            Vue.delete(this.columns,index);
        },
        toggle(action, item_id, editing, attributes) {
            this.active     = true;
            this.action     = action;
            this.editing    = editing;
            this.lang       = attributes.lang;
            let dataRoute   = decodeURI(attributes.dataRoute);
            if (dataRoute!==undefined) {
                if (dataRoute.indexOf("[id]")>0) {
                    dataRoute = dataRoute.replace("[id]", item_id);
                    
                }
                axios.get(dataRoute)
                .then((response) => {
                    this.columns = response.data.columns;
                    this.radar = response.data.graphs.radar;
                    this.bars = response.data.graphs.bars; 
                    this.range_value = response.data.range_value;
                    
                    //default
                    this.name = response.data.base.name;
                    this.description = response.data.base.description;
                    this.sorting = response.data.base.sorting;
                    this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);           
                    
                });
            }
        }
        
    }
    
}
</script>

